require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var BigInteger = require('bigi');

var Buffer = require('safe-buffer').Buffer;

var ecurve = require('ecurve');

var curve = ecurve.getCurveByName('secp256k1');

var math = require('./math');

var check = require('./check');

var convert = require('./convert');

var concat = Buffer.concat;
var G = curve.G;
var p = curve.p;
var n = curve.n;
var zero = BigInteger.ZERO;
var one = BigInteger.ONE;
var two = BigInteger.valueOf(2);
var three = BigInteger.valueOf(3);
var four = BigInteger.valueOf(4);
var seven = BigInteger.valueOf(7);

function sign(privateKey, message) {
  // https://github.com/sipa/bips/blob/bip-schnorr/bip-schnorr.mediawiki#signing
  var k0 = math.deterministicGetK0(privateKey, message);
  var R = G.multiply(k0);
  var k = math.getK(R, k0);
  var P = G.multiply(privateKey);
  var Rx = convert.intToBuffer(R.affineX);
  var e = math.getE(Rx, P, message);
  return concat([Rx, convert.intToBuffer(k.add(e.multiply(privateKey)).mod(n))]);
}

function verify(pubKey, message, signature) {
  check.checkVerifyParams(pubKey, message, signature); // https://github.com/sipa/bips/blob/bip-schnorr/bip-schnorr.mediawiki#verification

  var P = convert.pubKeyToPoint(pubKey);
  var r = convert.bufferToInt(signature.slice(0, 32));
  var s = convert.bufferToInt(signature.slice(32, 64));
  check.checkSignatureInput(r, s);
  var e = math.getE(convert.intToBuffer(r), P, message);
  var R = math.getR(s, e, P);

  if (R.curve.isInfinity(R) || math.jacobi(R.affineY) !== 1 || !R.affineX.equals(r)) {
    throw new Error('signature verification failed');
  }
}

function batchVerify(pubKeys, messages, signatures) {
  check.checkBatchVerifyParams(pubKeys, messages, signatures); // https://github.com/sipa/bips/blob/bip-schnorr/bip-schnorr.mediawiki#Batch_Verification

  var leftSide = zero;
  var rightSide = null;

  for (var i = 0; i < pubKeys.length; i++) {
    var P = convert.pubKeyToPoint(pubKeys[i]);
    var r = convert.bufferToInt(signatures[i].slice(0, 32));
    var s = convert.bufferToInt(signatures[i].slice(32, 64));
    check.checkSignatureInput(r, s);
    var e = math.getE(convert.intToBuffer(r), P, messages[i]);
    var c = r.pow(three).add(seven).mod(p);
    var y = c.modPow(p.add(one).divide(four), p);

    if (c.compareTo(y.modPow(two, p)) !== 0) {
      throw new Error('c is not equal to y^2');
    }

    var R = ecurve.Point.fromAffine(curve, r, y);

    if (i === 0) {
      leftSide = leftSide.add(s);
      rightSide = R.add(P.multiply(e));
    } else {
      var a = math.randomA();
      leftSide = leftSide.add(a.multiply(s));
      rightSide = rightSide.add(R.multiply(a)).add(P.multiply(a.multiply(e)));
    }
  }

  if (!G.multiply(leftSide.mod(n)).equals(rightSide)) {
    throw new Error('signature verification failed');
  }
}

function naiveKeyAggregation(privateKeys, message) {
  if (!privateKeys || !privateKeys.length) {
    throw new Error('privateKeys must be an array with one or more elements');
  }

  var k0s = [];
  var P = null;
  var R = null;

  var _iterator = _createForOfIteratorHelper(privateKeys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var privateKey = _step.value;
      var k0i = math.deterministicGetK0(privateKey, message);
      var Ri = G.multiply(k0i);
      var Pi = G.multiply(privateKey);
      k0s.push(k0i);

      if (R === null) {
        R = Ri;
        P = Pi;
      } else {
        R = R.add(Ri);
        P = P.add(Pi);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var Rx = convert.intToBuffer(R.affineX);
  var e = math.getE(Rx, P, message);
  var s = zero;

  for (var i = 0; i < k0s.length; i++) {
    var k = math.getK(R, k0s[i]);
    s = s.add(k.add(e.multiply(privateKeys[i])));
  }

  return concat([Rx, convert.intToBuffer(s.mod(n))]);
}

module.exports = {
  sign: sign,
  verify: verify,
  batchVerify: batchVerify,
  naiveKeyAggregation: naiveKeyAggregation
};